export default "__VITE_ASSET__BXK2u0kG__"